import { getRandomBase64Code } from "./getRandomBase64Code";

export function generateCodeVerifier(): string {
    return getRandomBase64Code(48);
}
